
<div>
  <div class="dropzone" :class="{ hovered: hovered, disabled: disabled }" @dragover.prevent="dragOver" @dragenter.prevent
    @drop.prevent="handleDrop" @dragenter="dragEnter" @dragleave="dragLeave" :disabled="disabled">
    <div class="d-flex flex-column mb-4">
      <v-icon large color="primary" class="mb-4">mdi-file-upload</v-icon>
      <span>Drag and Drop file here or <span class="font-weight-bold cursor-pointer"
        :style="{ color: disabled ? '#C0C0C0' : '#007BFF', textDecoration: disabled ? 'none' : 'underline', cursor: disabled ? 'not-allowed' : 'pointer' }"
          @click="chooseFile">Choose File</span> (10 File Max)</span>
    </div>
    <input type="file" multiple ref="fileInput" style="display: none;" @change="handleFiles" :disabled="disabled"/>
  </div>
  <div class="my-4">
    <div class="d-flex justify-content-between mb-2">
      <span class="color-grey-1">Supported format: <span class="font-weight-bold">.JPG, .JPEG, .PNG, .DOC, .DOCX,
          .XLS, .XLSX, .PDF, .CSV, .PPTX, .PPT, .ZIP</span></span>
    </div>
    <span v-if="disabled" class="font-weight-bold" style="color: #F2994A;">You've reached the maximum upload limit of 10 files.</span>
  </div>
</div>
